import { createContext, useEffect, useReducer, useState } from "react";
import EditorReducer from "./EditorReducer";

const initialState = {
  documents: [
    // {
    // id: 'doc1', // Par exemple, chaque document a un id unique
    // name: 'Document 1',
    // pages: [
    // {
    // id: 'page1', // Chaque page a un id unique
    // text: '',
    // },
    // ],
    // },
  ],
};


const EditorContext = createContext();

export const EditorProvider = ({ children }) => {
  const [state, dispatch] = useReducer(EditorReducer, initialState, () => {
    const storedState = localStorage.getItem("documentState");
    return storedState ? JSON.parse(storedState) : initialState;
  });

  useEffect(() => {
    localStorage.setItem("documentState", JSON.stringify(state));
  }, [state]);

  return (
    <EditorContext.Provider value={{ state, dispatch }}>
      {children}
    </EditorContext.Provider>
  );
};

export default EditorContext;